import { defineComponent as $, computed as m, openBlock as a, createElementBlock as B, normalizeClass as i, createVNode as r, unref as l, withCtx as h, createBlock as n, createCommentVNode as c, resolveDynamicComponent as g } from "vue";
import { RevButtonBase as x } from "@ds/components/ButtonBase";
import { RevButtonIcon as p } from "@ds/components/ButtonIcon";
import { RevIllustration as y } from "@ds/components/Illustration";
import A from "../../../icons/generated/IconCross.vue2.js";
import D from "../../../icons/generated/IconDownload.vue2.js";
import _ from "../../../icons/generated/IconImageInSquareFilled.vue2.js";
import L from "../../../icons/generated/IconPieChartInSquareFilled.vue2.js";
import I from "../../../icons/generated/IconSpeakerInSquareFilled.vue2.js";
import N from "../../../icons/generated/IconSpreadsheetInSquareFilled.vue2.js";
import R from "../../../icons/generated/IconTextAndImageInSquareFilled.vue2.js";
import T from "../../../icons/generated/IconTextInSquareFilled.vue2.js";
import V from "../../../icons/generated/IconVideoCameraInSquareFilled.vue2.js";
import j from "../../../icons/generated/IconZipperInSquareFilled.vue2.js";
import { tw as s } from "../../../utils/tailwind.js";
import { isImage as k, isPresentation as z, isAudio as P, isSpreadsheet as E, isPdf as S, isTextDocument as q, isVideo as F } from "../Document.helpers.js";
import G from "./DocumentLabelWrapper.vue2.js";
import H from "./DocumentName.vue2.js";
const J = ["aria-label"], se = /* @__PURE__ */ $({
  name: "DocumentDefault",
  __name: "DocumentDefault",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(e, { emit: v }) {
    const o = e, C = v, f = m(() => {
      const b = [
        {
          check: k,
          component: _,
          fillClass: "fill-file-image"
        },
        {
          check: z,
          component: L,
          fillClass: "fill-file-presentation"
        },
        {
          check: P,
          component: I,
          fillClass: "fill-file-audio"
        },
        {
          check: E,
          component: N,
          fillClass: "fill-file-spreadsheet"
        },
        {
          check: S,
          component: R,
          fillClass: "fill-file-pdf"
        },
        {
          check: q,
          component: T,
          fillClass: "fill-file-document"
        },
        {
          check: F,
          component: V,
          fillClass: "fill-file-video"
        }
      ];
      for (const t of b)
        if (t.check(o.name)) return t;
      return {
        component: j,
        fillClass: "fill-file-general"
      };
    }), u = m(
      () => o.url && o.thumbnail && k(o.name)
    ), w = m(() => [
      s`border-static-default-mid group relative w-full border`,
      u.value && s`flex-col`
    ]), d = s`absolute bottom-12 right-12`;
    return (b, t) => (a(), B("article", {
      "aria-label": e.name,
      class: i(w.value)
    }, [
      r(l(x), {
        "aria-label": e.name,
        class: "focus-visible-outline-default-hi block w-full max-w-full rounded-[5px]",
        target: "_blank",
        title: e.name,
        to: e.url
      }, {
        default: h(() => [
          u.value ? (a(), n(l(y), {
            key: 0,
            alt: "",
            height: 140,
            "image-class-names": "rounded-t-sm h-[8.75rem] w-full object-cover object-center",
            src: e.url,
            title: e.name,
            width: 448
          }, null, 8, ["src", "title"])) : c("", !0),
          r(G, { class: "w-full max-w-full overflow-hidden py-20 pr-48" }, {
            default: h(() => [
              (a(), n(g(f.value.component), {
                class: i(["shrink-0", f.value.fillClass]),
                size: "24"
              }, null, 8, ["class"])),
              r(H, { name: e.name }, null, 8, ["name"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["aria-label", "title", "to"]),
      e.url && !e.deletable ? (a(), n(l(p), {
        key: 0,
        "aria-label": e.downloadButtonAriaLabel,
        class: i(d),
        download: e.name,
        icon: l(D),
        target: "_blank",
        to: e.url,
        variant: "ghost"
      }, null, 8, ["aria-label", "download", "icon", "to"])) : c("", !0),
      e.deletable ? (a(), n(l(p), {
        key: 1,
        "aria-label": e.deleteButtonAriaLabel,
        class: i(d),
        icon: l(A),
        variant: "ghost",
        onClick: t[0] || (t[0] = (K) => C("delete"))
      }, null, 8, ["aria-label", "icon"])) : c("", !0)
    ], 10, J));
  }
});
export {
  se as default
};
